export default __webpack_public_path__ + "static/media/Greta 9781408362426.1b1dc7b5.jpg";